<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<template>
  <div class="flex flex-col gap-4">
    <!-- Overview card per ticket -->
    <div v-for="(item, index) in items" :key="item.ticket_id" class="flex flex-col">
      <!-- Ticket Summary Row -->
      <div class="flex justify-start items-center">
        <!-- Image -->
        <div v-if="item.event?.venue_id" class="flex-shrink-0">
          <img v-if="imageUrl" :src="imageUrl" alt="Category Image" class="w-20 h-13 object-cover rounded-md mr-2" />
        </div>
        <!--Ticket Summary -->
        <div class="flex flex-col flex-grow">
          <div class="flex flex-col gap-1">
            <div class="text-foreground font-semibold">{{ item.event?.event_name }}</div>
            <div class="flex justify-between items-center text-foreground">
              <div class="flex items-center justify-center cursor-pointer" @click="toggleDetails(index)">
                <span class="inline-block">{{ $t("Show Details") }}</span>
                <IcRoundArrowForwardIos v-if="openDetailsIndex === index" class="ml-1 size-4 inline-block rotate-90" />
                <IcRoundArrowForwardIos v-else class="inline-block ml-1 size-4" />
              </div>
              <div class="font-semibold text-muted-foreground ml-2">
                <span class="text-sm">
                  <span>{{ item.amount }}</span>
                </span>
                x
                <span class="inline-block">
                  <Euros
                    :amount="item.amount ? item.ticket?.local_rates?.net_rate_eur! : 0"
                    class="font-semibold"
                    :net-amount="item.amount ? item.ticket?.local_rates?.net_rate! : 0"
                    :calc-fx-rate="true"
                    :original-currency="item.ticket?.currency_code ? item.ticket?.currency_code : undefined"
                /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Event Details - Now part of the flex column for each ticket -->
      <EventDetails v-if="openDetailsIndex === index" :is-open="true" :item="item" class="ml-2" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useCartStore } from "@/store/cart";
import Euros from "@/components/Euros.vue";
import { computed, ref, watch } from "vue";
import { api } from "@xs2event/js-lib/util";
import IcRoundArrowForwardIos from "~icons/ic/round-arrow-forward-ios";

import EventDetails from "@/components/checkout/b2c/ticketSummary/EventDetails.vue";
const cartStore = useCartStore();
const items = computed(() => cartStore.items as unknown[]);
import config from "@/config";

const categoryImg = ref();

const openDetailsIndex = ref<number | null>(null);

const toggleDetails = (index: number) => {
  if (openDetailsIndex.value === index) {
    openDetailsIndex.value = null; // Close if already open
  } else {
    openDetailsIndex.value = index; // Open this item's details
  }
};

const IMAGE_SIZE = "thumbnail";
const imageUrl = computed(() => {
  if (!categoryImg.value?.[0]) {
    return undefined;
  }

  const img = categoryImg.value[0];

  if (!img.media_sizes?.includes(IMAGE_SIZE)) {
    return undefined;
  }

  const extensions = ["jpg", "jpeg", "png"];
  if (extensions.some((ext) => img.filename.endsWith(`.${ext}`))) {
    return undefined;
  }

  return encodeURI(`${config.MEDIA_CONTENT_URL}/category/${img.related_id}/image/${img.filename}_${IMAGE_SIZE}`);
});

const fetchCategoryImage = async (categoryId: string) => {
  const resp = await api.get(`/mediacontent/category/${categoryId}/image`);
  return resp.data.mediacontents;
};

watch(
  items,
  async (newItems) => {
    if (newItems.length > 0 && newItems?.[0].ticket?.category_id) {
      categoryImg.value = await fetchCategoryImage(newItems?.[0].ticket?.category_id);
    }
  },
  { immediate: true }
);
</script>
